module.exports = __webpack_public_path__ + "img/unpublished.a7da55de.svg";